/* RESPONSIBLE TEAM: team-automation-foundations */
import type Store from '@ember-data/store';
import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import type IntlService from 'embercom/services/intl';
import type ReportingMetrics from 'embercom/services/reporting-metrics';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';
import type Transition from '@ember/routing/transition';
import { hash } from 'rsvp';

export default class FinAIAgentTasksIndexRoute extends Route {
  @service declare intl: IntlService;
  @service declare appService: AppService;
  @service declare store: Store;
  @service declare reportingMetrics: ReportingMetrics;
  @service declare router: RouterService;

  get titleToken() {
    return this.intl.t('standalone.tasks.list.title');
  }

  async beforeModel(transition: Transition) {
    // Redirect to procedures if feature flag is on
    if (this.appService.app.canUseFinProcedures) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.procedures', {
        queryParams: transition.to?.queryParams || {},
      });
      return;
    }

    await this.reportingMetrics.loadMetricsAndProperties();
  }

  async model() {
    let messengerSettingsLanguages = await this.store.findRecord(
      'messenger-settings/languages',
      this.appService.app.id,
    );

    return hash({
      languages: messengerSettingsLanguages,
    });
  }
}
